export * from './aleDataUpload.component';



// WEBPACK FOOTER //
// ./src/app/AleDataUpload/index.ts